import {Component, OnInit, AfterViewInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonService} from '../common.service';
import {ApiService} from '../api.service';
import {AppShareNewService} from './app-share-new.service';

@Component({
  selector: 'app-share',
  templateUrl: './app-share.component.html',
  styleUrls: ['./app-share.component.css'],
})
export class AppShareComponent implements OnInit, AfterViewInit{

  appShareService: AppShareNewService;
  learningPathMetaId: any; //能力id
  shareData: any; //分享数据
  goldenSentences: string; //金句
  userName: string; //用户名
  headImgUrl: string; //用户头像（地址）
  overcomeRatio: string; //打败比例
  isShowPage: boolean = false; //是否显示页面
  assetsRoute: string = "../../assets"; //静态资源路径
  courseName: string; //课程名称
  author: string; //作者
  isShowHead: boolean = true;
  isShowDownloadTip: boolean = true;
  isShareAfter: boolean = false;
  startTime: any;
  endTime: any;

  buttonTheme: any = {
    'position':'inherit',
    'fontSize': 'fontSize15',
    'buttonElem':[
      {
        'color': 'blue',
        'text': '保存图片',
        'className': 'inlineBlockRadiusBtn width-60 height-35 margin-auto'
      }
    ]

  }; //按钮主题

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService) {
  }


  ngOnInit() {
    this.appShareService = new AppShareNewService(this.apiService);
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.route.params.subscribe(params => {
      this.learningPathMetaId = params['learningPathMetaId'];
      this.appShareService.getShareData(this.learningPathMetaId).then(result => {
        this.shareData = result;
      }).then(() => {
        this.goldenSentences = this.shareData.goldenSentences;
        this.userName = this.shareData.userName;
        this.headImgUrl = this.shareData.headImgUrl ? this.shareData.headImgUrl : this.assetsRoute+'/picture/share/default.png';
        this.overcomeRatio = this.shareData.overcomeRatio;
        this.author = this.shareData.author;
        this.courseName = this.commonService.getCourseNameWithLearningPathMetaId(Number(this.learningPathMetaId));
        this.isShowPage = true;
      });
    });
  }

  ngAfterViewInit() {
    this.commonService.initPage();
  }

  //关闭分享
  closeSharePage(){
    this.isShowPage = false;
    setTimeout(()=>{
      if(localStorage.getItem('skuId') && !localStorage.getItem('onlyCamp')){
        this.router.navigate(['learning-camp',localStorage.getItem('skuId'),localStorage.getItem('campId')]);
      }else if(localStorage.getItem('skuId') && localStorage.getItem('onlyCamp')){
        this.router.navigate(['learning-camp',localStorage.getItem('skuId'),localStorage.getItem('campId'),-1]);
      }else if(!localStorage.getItem('skuId')){
        const projectId = localStorage.getItem("projectId")
        if(projectId){
          this.router.navigate(['learning-project',projectId]);
          return
        }
        this.router.navigate(['learning-map']);
      }
    },1000);
  }


  //H5转png
  savePic(){
    let dom = document.getElementById('cut-wrap');
    // let width = dom.scrollWidth;
    // let height = dom.scrollHeight;
    let width = dom.offsetWidth;
    let height = dom.offsetHeight;

    let scale = this.setDPR();
    let y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    let cs = document.createElement('canvas');
    cs.width = width * scale;
    cs.height = height * scale;
    cs.style.width =  cs.width+'px';
    cs.style.height = cs.height+'px';
    let ctx = cs.getContext('2d');
    ctx.scale(scale, scale);

    $(dom).scrollTop(0,y);

    html2canvas(dom,{
      backgroundColor: '#FFFFFE',
      canvas: cs,
      scale: scale/scale,
      useCORS: true,
      allowTaint: true,
      taintTest: false,
      width: width,
      height: height
    }).then((canvas)=>{
      let context = canvas.getContext('2d');
      context.mozImageSmoothingEnabled = false;
      context.webkitImageSmoothingEnabled = false;
      context.msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;
      $('.canvas-img').attr('src',canvas.toDataURL("image/png", 1.0));
    }).then(()=>{
      $('.app-share-wrap').hide();
      $('.canvas-image-wrap').show().addClass('scaleSmall');
      this.commonService.initPage();
    });
  }


  //根据window.devicePixelRatio获取像素比
  setDPR(){
    return window.devicePixelRatio && window.devicePixelRatio > 1 ? window.devicePixelRatio : 1;
  }

  closePic(){
    $('.app-share-wrap').show();
    $('.canvas-image-wrap').hide();
    if(localStorage.getItem('skuId') && !localStorage.getItem('onlyCamp')){
      this.router.navigate(['learning-camp',localStorage.getItem('skuId'),localStorage.getItem('campId')]);
    }else if(localStorage.getItem('skuId') && localStorage.getItem('onlyCamp')){
      this.router.navigate(['learning-camp',localStorage.getItem('skuId'),localStorage.getItem('campId'),-1]);
    }else if(!localStorage.getItem('skuId')){
      const projectId = localStorage.getItem("projectId")
      if(projectId){
        this.router.navigate(['learning-project',projectId]);
        return
      }
      this.router.navigate(['learning-map']);
    }
  }


  clickSavePic(){
    $('.app-share-head').find('.close-btn').hide();
    $('.app-share-btn').hide();
    this.isShareAfter = true;
    setTimeout(()=>{
      this.savePic();
    },500);
  }


  //长按开始
  onMouseDown(event){
    this.startTime = new Date().getTime();
  }


  //长按结束
  onMouseUp(event){
    this.endTime = new Date().getTime();
    if(this.endTime > this.startTime + 800){
      $('.close-btn').hide();
      $('.app-share-tip').hide();
      setTimeout(()=>{
        this.savePic();
      },100);
    }else{
      return;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/app-share/app-share.component.ts